import { Injectable } from '@angular/core';

@Injectable()
export class EndpointsConfigService {

  constructor() { }

  public ApiUrl = '/ib-security/';
  
  public readonly getLoginPollAuthCodeUrl = "secure/banking/sca/devices/authorization/status";

  public readonly getApplicationDetails = "secure/banking/applications";

  public readonly getCardsVerifySCAUrl = "secure/banking/cards";
   
}
